import {sendCustomEvent} from "./base";

const EVENT_NAME = "deepl_translate";

export const translateEvent = (category) => {
    sendCustomEvent(EVENT_NAME, category, "Translate language");
}